import { UseFormSetValue } from 'react-hook-form';
import { revaluation as rules } from 'further-ui/validations';
import revaluationQueriesFactory from '../useRevaluations/revaluationQueriesFactory';
import { Revaluation, InvestmentHistory } from '../../types';

export const updateAllNewRevaluationsUnitPrice = (
  value: number,
  newRevaluations: Array<Omit<Revaluation, 'revaluationId'>>,
  investmentHistory: InvestmentHistory,
  setValue: UseFormSetValue<rules.RevaluationFormType>,
) => {
  const { getUnitsPerHoldingClass } = revaluationQueriesFactory({
    investmentHistory,
    newRevaluations,
    revaluations: [],
    revaluationFormFields: [],
  });

  newRevaluations.forEach((revaluation) => {
    const revaluationIndex = newRevaluations.findIndex(
      (rev) => rev.holdingClassId === revaluation.holdingClassId,
    );

    if (revaluationIndex === -1) {
      return;
    }

    setValue(`newRevaluations.${revaluationIndex}.unitPriceTcy`, value);

    const numberOfUnits = getUnitsPerHoldingClass(
      investmentHistory,
      revaluation.holdingClassId ?? '',
    );

    if (numberOfUnits > 0) {
      setValue(
        `newRevaluations.${revaluationIndex}.currentHoldValue`,
        value * numberOfUnits,
      );
    }
  });
};

export const updateAllNewRevaluationsHoldValue = (
  value: number,
  newRevaluations: Array<Partial<Revaluation>>,
  setValue: UseFormSetValue<rules.RevaluationFormType>,
) => {
  newRevaluations.forEach((_revaluation, index) => {
    setValue(`newRevaluations.${index}.currentHoldValue`, value);
  });
};

export const updateAllNewRevaluationsDate = (
  date: Date,
  newRevaluations: Array<Partial<Revaluation>>,
  setValue: UseFormSetValue<rules.RevaluationFormType>,
) => {
  newRevaluations.forEach((_, index) => {
    setValue(`newRevaluations.${index}.ledgerDate`, date);
  });
};
